import React from 'react';

const WhatsAppWidget = () => {
  return (
    <a
      href="https://wa.me/19292359419"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 z-40  transition-transform duration-300"
    >
      <img
        src="/assets/whatsapp.png"
        alt="WhatsApp"
        className="sm:w-[60px] w-[56px] h-[56px] sm:h-[60px] object-contain drop-shadow-lg"
      />
    </a>
  );
};

export default WhatsAppWidget;
